<template>
   <el-container class="content" style="display: block;">
     <div class="" style="width: 80%;height: 80%;object-fit: contain;">
       <img :src="require('@/assets/image/j1.gif')" @click="goshipin()" style="object-fit: contain;position: fixed;right: 45%;top: 35%;z-index: 1005;background-color: #000000;" :style="{'width': screenWidth*0.12+'px','height': screenWidth*0.12+'px'}">
     </div>
     <div class="daohangw" style="position: absolute;right: 50%;top: 30%;" >
       <div style="position: fixed;right: 0;top: 0;" :class="{cdaohang:cshow}" :style="{'width': screenWidth*0.23+'px','height': screenWidth*0.23+'px'}">
         <div class="" style="width: 80%;height: 80%;object-fit: contain;">
           <img :src="require('@/assets/image/h1.gif')" @click="cshows()" style="object-fit: contain;position: fixed;right: 0;top: 0%;background-color: #000000;" :style="{'width': screenWidth*0.12+'px','height': screenWidth*0.12+'px'}">
         </div>
         <div class="" style="object-fit: contain;" v-if="cshow">
                     <img :src="require('@/assets/image/h2.gif')" @click="cshows1()" style="object-fit: contain;position: fixed;right: 13%;top: 3%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
           <ul style="z-index: 1005;position: fixed;right: 12%;top: 15%;background-color: #001524;line-height: 25px;width: 8%;text-indent: 15%;" v-if="cshow1">
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing2')" command="changjing2">宇宙之幂办公岛</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing3')" command="changjing3">宇宙之幂生产总部</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing')" command="changjing">宇宙之幂员工生活区</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('changjing1')" command="changjing1">宇宙之幂深圳总部</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu')" command="renwu">宇宙之幂宇宙人CEO</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu1')" command="renwu1">宇宙之幂宇宙人CTO</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu2')" command="renwu2">宇宙之幂具象人小樱</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu3')" command="renwu3">宇宙之幂具象人小兔</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu4')" command="renwu4">宇宙之幂代言人</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu5')" command="renwu5">宇宙之幂代言人</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu6')" command="renwu6">宇宙之幂职业人安保</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu7')" command="renwu7">宇宙之幂员工保健员</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu8')" command="renwu8">宇宙之幂员工销售员</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu9')" command="renwu9">宇宙之幂员工行政员</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('renwu10')" command="renwu10">宇宙之幂员工的小宠物</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu1')" command="dianpu1">宇宙之幂员工的小咖啡店</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu2')" command="dianpu2">宇宙之幂员工的小奶茶店</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu3')" command="dianpu3">宇宙之幂员工的小饭堂</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('dianpu4')" command="dianpu4">宇宙之幂员工的小储蓄所</li>
           </ul>

         </div>
         <div class="" style="object-fit: contain;" v-if="cshow">
           <img :src="require('@/assets/image/h4.gif')" @click="cshows2()" style="object-fit: contain;position: fixed;right: 13%;top: 25%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
           <ul style="z-index: 1005;position: fixed;right: 8%;top: 42%;background-color: #001524;line-height: 25px;width: 18%;text-indent: 5%;" v-if="cshow2" >
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company')" command="company">宇宙一次幂(深圳)机器人有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company1')" command="company1">宇宙人(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company2')" command="company2">秘文宇宙(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company3')" command="company3">宇宙职人(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company4')" command="company4">宇宙五次幂(深圳)文娱科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company5')" command="company5">七次幂(深圳)人工智能有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company6')" command="company6">宇宙械人(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company7')" command="company7">宠宠宇宙(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company8')" command="company8">宇宙空间模块(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company9')" command="company9">宇宙映射(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company10')" command="company10">子宇宙群(深圳)科技有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company11')" command="company11">软宇宙(深圳)软件有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company12')" command="company12">暗物质(深圳)系统有限公司_【宇宙级软件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company13')" command="company13">宇宙链(深圳)科技有限公司_【宇宙级软件制造】</li>

             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company14')" command="company14">单导(深圳)制造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company15')" command="company15">千亿光子(深圳)科技有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company16')" command="company16">超显电子(深圳)有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company17')" command="company17">沉与浸(深圳)智造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company18')" command="company18">运算盒子(深圳)制造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company19')" command="company19">硅脑(深圳)智造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company20')" command="company20">机甲(深圳)智造有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company21')" command="company21">世物诞生(深圳)产业科技有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company22')" command="company22">现品升宙(深圳)科技有限公司_【宇宙级硬件制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company23')" command="company23">世物宙化(深圳)科技有限公司_【宇宙级硬件制造】</li>

             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company24')" command="company24">产宇宙(深圳)产业科技有限公司_【宇宙级产业制造】</li>
             <li style="font-size: 15px;color: #ffffff;" @click="toPage('company25')" command="company25">构宇宙(深圳)产业科技有限公司_【宇宙级产业制造】</li>
           </ul>
         </div>
         <div class="" style="object-fit: contain;" v-if="cshow">
           <img :src="require('@/assets/image/h3.gif')" @click="cshows3()" style="object-fit: contain;position: fixed;right: 1%;top: 25%;" :style="{'width': screenWidth*0.1+'px','height': screenWidth*0.1+'px'}">
           <ul style="z-index: 1005;position: fixed;right: 0;top: 42%;background-color: #001524;line-height: 25px;width: 8%;text-indent: 15%;" v-if="cshow3" >
              <li style="font-size: 15px;color: #ffffff;" @click="toPage('jianjie')" command="jianjie">宇宙之幂简介</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('chanpin')" command="chanpin">宇宙之幂产品线</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('shifang')" command="shifang">宇宙之幂全球释放</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('yingshou')" command="yingshou">宇宙之幂全球营收</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('address')" command="address">宇宙之幂地址</li>
               <li style="font-size: 15px;color: #ffffff;" @click="toPage('contact')" command="contact">联系宇宙之幂</li>
           </ul>
         </div>
       </div>

     </div>
     <div :style="{'margin-top': '11px','width': '110%','height':'120%','margin-left': -(width/2+5)+'px','margin-top': -(width/1.3)+'px'}" @wheel="handleWheel">
       <div class="bordered-box">
         <div class="gradient-border" @click="show(item['id'])" :style="{'box-shadow': '-1px 0 2px '+listq[index]['yellow']+', 0 1px 2px '+listq[index]['blue']+', 1px 0 2px '+listq[index]['orange']+', 0 -1px 2px '+listq[index]['red'],'width': width+'px','height': height+'px','margin-left':index/wnum%2==1 ? (width/2+5)+'px' : '3px'}" v-for="(item, index) in list1" :key="index">
         	<!-- <img :src="'http://data3.yoooooo.com/guanwang/'+ item['img']+'.png'" class="imgs"> -->
           <img v-show="!item['t']"  :src="require('@/assets/image/zhanwei1.png')" class="imgs">
           <img v-show="item['t']"  :src="item['img']" class="imgs" v-on:error="onImageError" @load="loadImg(index)">
           <!-- <el-image :src="item['img']" class="imgs" style="object-fit: contain;">
              <div slot="placeholder" class="image-slot">
                   <img :src="require('@/assets/image/zhanwei.png')" class="imgs">
              </div>
           </el-image> -->
         </div>
       </div>
       <!-- <img :src="'http://data3.yoooooo.com/guanwang/'+ item['img']+'.png'" class="imgs"> -->

     </div>






     <!-- <el-dialog
       title=""
       :visible.sync="centerDialogVisible"

       center>
       <img :src="'http://data3.yoooooo.com/guanwang/zongxiang_00026.png'" class="imgs">

       <span slot="footer" class="dialog-footer">
     	<el-button @click="centerDialogVisible = false">取 消</el-button>
     	<el-button type="primary" @click="dosort()">确 定</el-button>
       </span>
     </el-dialog> -->
     <div :class="{'overlay':isOpen,'overlay1':!isOpen}" v-if="isOpen" @click="hides()" >

         <!-- <img  :src="require('@/assets/image/'+bigImg)" class="imgs"> -->
         <img  :src="bigImg" class="imgs" v-on:error="onImageError" style="object-fit: contain;">

     </div>
     <div class="beian">
      <!-- <a href="/jianjie" target="_blank" style="text-decoration:none;color: #fff;background-color: black;margin-right: 10px;">简介</a>
      <a href="/chanpin" target="_blank"  style="text-decoration:none;color: #fff;background-color: black;margin-right: 10px;">产品线</a>
      <a href="/shifang" target="_blank"  style="text-decoration:none;color: #fff;background-color: black;margin-right: 10px;">全球释放</a>
      <a href="/yingshou" target="_blank"  style="text-decoration:none;color: #fff;background-color: black;margin-right: 10px;">全球营收</a>
      <a href="/address" target="_blank"  style="text-decoration:none;color: #fff;background-color: black;margin-right: 10px;" >地址</a>
      <a href="/contact" target="_blank"  style="text-decoration:none;color: #fff;background-color: black;margin-right: 10px;">联系我们</a> -->

      <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


     </div>
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        cshow:false,
        cshow1:false,
        cshow2:false,
        cshow3:false,
        isOpen: false,
        bigImg:'',
        list:[],
        list1:[],
        listq:[],
        listz:[],
        blue:'rgba(0, 0, 255, 1)',
        yellow:'rgba(255, 255, 0, 1)',
        orange:'rgba(255, 165, 0, 1)',
        red:'rgba(255, 0, 0, 1)',

        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        width:(window.innerWidth*1.1-31*6.5)/30,
        height:(window.innerWidth*1.1-31*6.5)/30,
        scrollUp: 0,
        scrollDown: 0,
        wnum:30,
        shows_id:0,
        cli:false,
        clir:false,
        clio:false
      };
    },
    mounted() {
        // document.addEventListener('click', () => {
        //       if (this.isOpen) {
        //         this.isOpen = false;
        //       }
        //     });
        // 监听滚轮事件
        document.addEventListener('wheel', this.preventScroll, { passive: false });
      },
      beforeDestroy() {
        // 移除事件监听
        document.removeEventListener('wheel', this.preventScroll);
        document.removeEventListener('click', () => {});
      },
    created() {

      //   this.images.push('./static/imgs/ali_0'+i+'.png')
      window.oncontextmenu = function () { return false; };
      window.onselectstart = function () { return false; };
      window.onkeydown = window.onkeyup = window.onkeypress = function () {
          window.event.returnValue = false;
          return false;
      }
      this.loadings()
      this.getScreen()
      this.loadList()

      this.startAnimation()


    },

	methods:{
    cshows(){
      this.cshow = !this.cshow
      if(!this.cshow){
        this.cshow1 = false
        this.cshow2 = false
        this.cshow3 = false
      }

    },
    cshows1(){
      this.cshow1 = !this.cshow1
      if(this.cshow1){
        this.cshow2 = false
        this.cshow3 = false
      }
    },
    cshows2(){
      this.cshow2 = !this.cshow2
      if(this.cshow2){
        this.cshow1 = false
        this.cshow3 = false
      }
    },
    cshows3(){
      this.cshow3 = !this.cshow3
      if(this.cshow3){
        this.cshow1 = false
        this.cshow2 = false
      }
    },
    goshipin(){
      this.$router.push('/shop');
    },
    toPage(name){
      this.$router.push('/'+name);
    },
    toHome(command) {
      this.$router.push('/');
    },
    vchangeo(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clio = true
      }else{
        this.clio = false
      }
    },
    test(){
      setTimeout(()=>{
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {


          element.style.display = 'none';
          // element.remove()
        });
      },10)

    },
    vchangel(e){

      if(e){
        this.cli = true
        var elements = document.querySelectorAll(".popper__arrow");
        elements.forEach(function(element) {

          element.style.display = 'none';
          // element.remove()
        });
      }else{
        this.cli = false
      }
    },
    vchanger(e){
      var elements = document.querySelectorAll(".popper__arrow");
      elements.forEach(function(element) {
        element.style.display = 'none';

      });
      if(e){
        this.clir = true
      }else{
        this.clir = false
      }
    },
    handleCommand(command) {
      this.$router.push('/'+command);
    },
    loadImg(index){
      var items = this.list1[index]
      this.$set(this.list1, index, {'id':items['id'],'name':items['name'],'img':items['img'],'imgs':items['imgs'],'t':true});
    },
    loadings(){
      this.wnum = 30
      if(window.innerWidth == 2048){
        this.wnum = 29
      }
      if(window.innerWidth == 1920){
        this.wnum = 24
      }
      if(window.innerWidth == 1856){
        this.wnum = 25
      }
      if(window.innerWidth == 1792){
        this.wnum = 23
      }
      if(window.innerWidth == 1680){
        this.wnum = 21
      }
      if(window.innerWidth == 1600){
        this.wnum = 20
      }
      if(window.innerWidth == 1440){
        this.wnum = 19
      }
      if(window.innerWidth == 1400){
        this.wnum = 18
      }
      if(window.innerWidth == 1366 || window.innerWidth == 1360){
        this.wnum = 18
      }
      if(window.innerWidth == 1280){
        this.wnum = 18
      }
      if(window.innerWidth == 1152){
        this.wnum = 16
      }
      if(window.innerWidth == 1024){
        this.wnum = 14
      }
      if(window.innerWidth == 800){
        this.wnum = 12
      }
      this.width = (window.innerWidth*1.1-(this.wnum+1)*6.5)/this.wnum
      this.height = (window.innerWidth*1.1-(this.wnum+1)*6.5)/this.wnum
    },

    onImageError(event){
      event.target.src = require('@/assets/image/zhanwei.png');
    },
    getScreen() {
      if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i )){
        window.location.href='http://m.universe.top/'

      }

    },
    handleWheel(event) {
          const delta = event.deltaY;
          if (delta > 0) {
            // 向上滚动
            var olds = []
            var news = []
            var that = this
            var nums = that.list.length-that.wnum-1
            // console.log(nums,'nums')
            this.list.forEach(function(item, index) {
              if(index>nums){
                news.push(item)
                // that.list.splice(index, 1);
              }
            })
            that.list.splice(nums, that.wnum);
            // console.log(that.list.length,'news')

            this.list1.forEach(function(item, index) {
              if(index < that.wnum){
                olds.push(item)
                that.list1.splice(index, 1);
              }
            })
            olds.forEach(function(item, index) {
              that.list.unshift(item)

            })
            news.forEach(function(item, index) {
              that.list1.push({'id':item['id'],'name':item['name'],'img':item['img']})
            })
            // console.log(that.list1.length,'olds')
            // console.log(that.list1.length,'list1')

          } else if (delta < 0) {
            // 向下滚动

            var olds = []
            var news = []
            var that = this
            var nums = that.list.length-that.wnum-1
            this.list.forEach(function(item, index) {
              if(index < that.wnum){
                // console.log(item,'new')

                news.push(item)
                that.list.splice(index, 1);
              }
            })
            this.list1.forEach(function(item, index) {
              if(index>nums){
                olds.push(item)
              }
            })
           that.list1.splice(nums, that.wnum);
            olds.forEach(function(item, index) {
              that.list.push(item)
            })
            news.forEach(function(item, index) {
              that.list1.unshift({'id':item['id'],'name':item['name'],'img':item['img']})
            })

          }
        },
    // show(index,imgs){
    //   this.listz = imgs
    //   this.isOpen = true
    //   var bigImgs = this.listz

    //   var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
    //   this.bigImg = img

    // },
    showc(id,ids){
      if(this.isOpen && this.shows_id == id){
        this.show(ids)
      }
    },
    show(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id

      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/loadBIgImg'
      })
      .then(res=>{
        this.listz = res.data.data;
        this.shows_id = id
        this.isOpen = true
        var bigImgs = this.listz
        var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
        this.bigImg = img
      })
      .catch(err=>{

      });


    },
    hides(){
      this.isOpen = false
    },

    preventScroll(event) {
          // 阻止滚轮事件
      event.preventDefault();
    },

        startAnimation(m,n) {
          var that = this

          this.interval1 = setInterval(() => {
            if(that.isOpen){
              var bigImgs = that.listz

              var img = bigImgs[Math.floor(Math.random() * bigImgs.length)]
              that.bigImg = img
              that.$forceUpdate()

              console.log(that.bigImg)
            }


          }, 8000);
          this.interval2 = setInterval(() => {

            that.listq.forEach(function(item, index) {
              var blue = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+',1)'
              var yellow = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', 1)'
              var orange = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', 1)'
              var red = 'rgba('+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', '+(Math.floor(Math.random() * 111)+145)+', 1)'
              if(item['num']<item['nums']){
                that.$set(that.listq, index, {'blue':blue,'yellow':yellow,'orange':orange,'red':red,'num':item['num']+1,'nums':item['nums']});
              }else{
                // console.log(index,'替换')
                var tt = Math.floor(Math.random() * that.list.length)
                var items = that.list[tt]
                var old = that.list1[index]

                that.showc(that.list1[index]['id'],items['id'])
                that.$set(that.list1, index, {'id':items['id'],'name':items['name'],'img':items['img'],'t':true});
                that.$set(that.list, tt, old);
                that.$set(that.listq, index, {'blue':blue,'yellow':yellow,'orange':orange,'red':red,'num':0,'nums':item['nums']});
              }

            })

          }, 200);

        },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,

      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/loadGuanwang1'
      })
      .then(res=>{
        this.list = res.data.data;
        this.list1 = res.data.data1;
        this.listq = res.data.dataq;
        this.listz = res.data.dataz;

      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
  .cdaohang{
    background-color: #000000;
  }
  ul li:hover{
    background-color: #cacaca;
  }
  .el-dropdown-menu__item{
    color: #ffffff;
    font-weight: bold;
    font-family: guanwangdaohang;
  }
  .popper__arrow{
    display: none;
  }
  .daohangclicolor{
    color: #cacaca;
  }
  .daohangnocolor{
    color: #ffffff;
  }
.daohangcli{
  height: 50px;
  border: #00b4ff 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #001d31;
}
.daohangno{
  height: 50px;
  border: #686868 1px solid;
  width: 350px;
  border-radius: 50px;
  background-color: #0071e3;
}
  .daohangw{
    position: fixed;
    z-index: 1000;
    left: 40%;
    top:0%;

  }
  .beian {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }
  .overlaydis{

    display: none;
  }
  .overlay {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }
  .el-main{
    height: 1800px;
  }
  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  .el-scrollbar__wrap{
    background-color: black;
  }
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }
.lefts{
  margin-left: 75px;
}
.rights{
  margin-right: 75px;
}
.gradient-border {
      float: left;
      /* margin-left: 5px; */
      margin-top: -9px;
	    position: relative;
	    /* width: 76px;
	    height: 76px; */
	    background: #fff;
	    border-radius: 50%;
	    overflow: hidden;
      /* margin:20px auto; */
      /* box-shadow: -1px 0 3px yellow, 0 1px 3px blue, 1px 0 3px orange, 0 -1px 3px red; */
      background-color: black;
	  }


	.imgs{
    position: absolute;
		width: 80%;
		height: 80%;
    object-fit: contain;
		left: 10%;
		top:10%;
	}

.daohangcliz{
    height: 50px;
    border: #00b4ff 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #001d31;
  }
  .daohangnoz{
    height: 50px;
    border: #686868 1px solid;
    width: 350px;
    border-radius: 50px;
    background-color: #0071e3;
  }



</style>



// WEBPACK FOOTER //
// src/components/main/shouye.vue